module.exports = __webpack_public_path__ + "Interface-Example.png?7c6b642bc690310874bd3a527c4f31f0";


//////////////////
// WEBPACK FOOTER
// ./static/Interface-Example.png
// module id = 31
// module chunks = 0